import { mergeStyleSets } from '@fluentui/react';

export const auditLogStyles = mergeStyleSets({
  container: {
    padding: '16px 0',
    maxHeight: '400px',
    overflowY: 'auto',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '48px 0',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '48px 0',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '48px 0',
  },
  entry: {
    display: 'flex',
    gap: '12px',
    marginBottom: '24px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '4px',
  },
  dot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: '#0078d4',
    flexShrink: 0,
  },
  line: {
    width: '2px',
    flex: 1,
    backgroundColor: '#c8c6c4',
    marginTop: '4px',
    minHeight: '32px',
  },
  content: {
    flex: 1,
    paddingTop: '0px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: '4px',
  },
  user: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#323130',
  },
  timestamp: {
    fontSize: '12px',
    color: '#605e5c',
  },
  change: {
    paddingLeft: '0',
  },
  fieldName: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#323130',
    marginBottom: '4px',
  },
  values: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    color: '#605e5c',
  },
  oldValue: {
    textDecoration: 'line-through',
    color: '#a4262c',
  },
  newValue: {
    fontWeight: 600,
    color: '#107c10',
  },
});
